<template>
  <div class="block-content-container">
    <div class="media-wrapper">
      <slot name="media"></slot>
    </div>
    <div class="text-content-container">
      <slot name="text-content"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'block-content',
};
</script>
<style lang="sass" scoped>
.block-content-container
  width: 100%
  height: 100%
  .media-wrapper
    width: 100%
    height: 100%
    img, video
      width: 100%
      height: 100%
      object-fit: cover
</style>
